import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Separator } from '@/components/ui/separator'
import { useLogout } from '@/contexts/auth/use-logout'
import useTranslator from '@/hooks/translation'
import { useAuthLogoutDialog } from '@/stores'

export function AuthLogoutDialog() {
  const { open, onOpenChange } = useAuthLogoutDialog()

  const { getTranslation } = useTranslator()

  const logoutUser = useLogout()

  const handleLogout = () => {
    logoutUser()
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md p-0">
        <DialogHeader className="px-6 pt-6">
          <DialogTitle>{getTranslation('components.menu.logout')}</DialogTitle>

          <DialogDescription className="pt-1">
            {getTranslation('common.modal.logout.warning')}
          </DialogDescription>
        </DialogHeader>

        <Separator />

        <div className="relative h-full w-full p-6">
          <p>{getTranslation('common.modal.logout.title')}</p>
        </div>

        <DialogFooter className="flex w-full gap-2 sm:justify-between">
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            {getTranslation('common.cancel')}
          </Button>

          <Button onClick={handleLogout} variant="fintalk">
            {getTranslation('components.menu.logout')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
